import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSwapVerticle = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 18,
	viewBox: "0 0 16 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.99967 13.2609C8.86388 14.4294 9.87344 15.479 11.0028 16.3836C11.0997 16.4612 11.2164 16.5 11.333 16.5M14.6663 13.2609C13.8021 14.4294 12.7926 15.479 11.6632 16.3836C11.5663 16.4612 11.4497 16.5 11.333 16.5M11.333 16.5V4.83333M1.33301 4.73911C2.19721 3.57056 3.20678 2.52102 4.33616 1.6164C4.43305 1.5388 4.54969 1.5 4.66634 1.5M7.99967 4.73911C7.13547 3.57056 6.12591 2.52102 4.99652 1.6164C4.89964 1.5388 4.78299 1.5 4.66634 1.5M4.66634 1.5V13.1667",
		stroke: "#71717A",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgSwapVerticle);
export default ForwardRef;
